import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createColorsReaction, editColorReaction,
seeListColorsReactions, deleteColorReaction } from '../../actions/colorsActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const ColorsReactionsAdmin = ({ history, createColorsReaction, editColorReaction, listColorsReaction, seeListColorsReactions, deleteColorReaction, isLoadingListColorsReaction }) => {

       useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListColorsReactions()
        })
        
    },[])
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [colorName, setColorName] = useState('')
    const [codeHexadecimalcolor, setCodeHexadecimalcolor] = useState('')
    const [valueInlikes, setValueInlikes] = useState('')
    const [isValidate, setValidate] = useState(false)
    const [error, setError] = useState({})
    const [isEnable, setEnable] = useState(false)

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    const isEmpty = (e) => {
        if (codeHexadecimalcolor !== ''  && colorName !== '' && valueInlikes !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} color de reacciones`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Codigo del color:'}
                    </div>
                    <input
                        name='codeHexadecimalcolor'
                        className='inputs-admin'
                        value={codeHexadecimalcolor}
                        onChange={(e) => {
                            setCodeHexadecimalcolor(e.target.value.trimStart())
                            if (codeHexadecimalcolor !== '' && colorName !== '' ) {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error  text-error-admin">{error.codeHexadecimalcolor}</div>
                    <div className="text-input-admin">
                        {'Nombre del color:'}
                    </div>
                    <input
                        name='colorName'
                        className='inputs-admin'
                        value={colorName}
                        onChange={(e) => {
                            setColorName(e.target.value.trimStart())
                            if (codeHexadecimalcolor !== '' && colorName !== '' ) {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error  text-error-admin">{error.colorName}</div>
                    <div className="text-input-admin">
                        {'Valor en likes:'}
                    </div>
                    <input
                        name='valueInlikes'
                        className='inputs-admin'
                        type='number'
                        min='1'
                        value={valueInlikes}
                        onChange={(e) => {
                            setValueInlikes(e.target.value.trimStart())
                            if (codeHexadecimalcolor !== ''  && colorName !== '' && valueInlikes !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error  text-error-admin">{error.valueInlikes}</div>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btn-create-edit btns-admin-inactive`} onClick={() => {
                                setCodeHexadecimalcolor('')
                                setColorName('')
                                setValueInlikes('')
                                setEnable(false)
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editColorReaction({ hexadecimal: codeHexadecimalcolor.trim(), colorName: colorName.trim(), colorId: idEdit, valueInlikes: valueInlikes }, indexEdit, history)
                                    setCodeHexadecimalcolor('')
                                    setColorName('')
                                    setValueInlikes('')
                                    setEnable(false)
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        : <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createColorsReaction({ hexadecimal: codeHexadecimalcolor.trim(), colorName: colorName.trim(), valueInlikes: valueInlikes }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>


                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Colores existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListColorsReaction ? <div>Cargando...</div> :
                        listColorsReaction.map((color, index) => (
                            <div key={color._id} className="card-admin">
                                <div className="tittle-card-admin">{color.colorName}</div>
                                <div className="text-content-card">Codigo: {color.hexadecimal}</div>
                                <div className="text-content-card">Valor en likes: {color.valueInlikes}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setCodeHexadecimalcolor(color.hexadecimal)
                                        setColorName(color.colorName)
                                        setValueInlikes(color.valueInlikes)
                                        setIdEdit(color._id)
                                        setEnable(color.isEnable)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteColorReaction(color._id, index) }}>Eliminar</div>

                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListColorsReaction: state.colorsReactionAdmin.isLoadingListColorsReaction,
        listColorsReaction: state.colorsReactionAdmin.listColorsReaction
    }
}


export default connect(mapStateToProps, { createColorsReaction, editColorReaction, seeListColorsReactions, deleteColorReaction })(ColorsReactionsAdmin)